module.exports = __webpack_public_path__ + "media/images/front/treatment_support/img_tutorial_02-5b79063f72187bd3bb238dc3c0d68d43.png";